import React from 'react';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import './ExportButton.css';

const ExportButton = ({
  label = 'Download XLSX',
  startIcon = <GetAppIcon />,
  className = '',
  ...rest
}) => (
  <Button
    variant="contained"
    color="primary"
    className={`export-btn common-export-button ${className}`.trim()}
    startIcon={startIcon}
    {...rest}
  >
    {label}
  </Button>
);

export default ExportButton;
